import  React from 'react';
import Link from 'react-router-dom/Link';

export default ({post, children, ...props}) =>
    <Link to={getPostHref(post)} {...props}>{children}</Link>;

export const getPostHref = (post) => '/blog/' + post.slug;


// WEBPACK FOOTER //
// ./src/modules/Blog/elements/PostLink.js